import {Component} from '@angular/core';
import {ScullyRoute, ScullyRoutesService, TransferStateService} from '@scullyio/ng-lib';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-media-holder',
  template: `
    <router-outlet></router-outlet>
  `,
})
export class MediaHolderComponent {
  media$ = this.sts.useScullyTransferState(
    'mediaRoutes',
    this.srs.available$.pipe(
      map((routeList) => routeList.filter((route: ScullyRoute) => route.route.startsWith(`/media/`))),
      map((pages) => pages.sort((a, b) => (a.published_at > b.published_at ? -1 : 1)))
    )
  );

  constructor(private srs: ScullyRoutesService, private sts: TransferStateService) {
  }
}
